import {
    APPEND_FILTER,
     RESET_FILTER
} from "./actionTypes"

const INITIAL_STATE = {
    location: '',
    area_ids: [],
    developer_id: null,
    compound_id: null,
    building_id: null
}

const adminFilterReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case APPEND_FILTER:
            return { ...state, ...action.payload }
        case RESET_FILTER:
            return {
                ...state,
                location: '',
                area_ids: [],
                developer_id: null,
                compound_id: null,
                building_id: null
            }
        default:
            return state
    }
}

export default adminFilterReducer
